import { render } from "./AwaitingActivation.vue?vue&type=template&id=638310d7&ts=true"
import script from "./AwaitingActivation.vue?vue&type=script&lang=ts"
export * from "./AwaitingActivation.vue?vue&type=script&lang=ts"

import "./AwaitingActivation.vue?vue&type=style&index=0&id=638310d7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__